// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__ZVNOL","text_danger":"TablaProducto_text_danger__QTzq6","text_success":"TablaProducto_text_success__2K9Gd"};